module.exports = __webpack_public_path__ + "static/media/pencil.90dd71b5.svg";